import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@app/ErrorBoundary';
import CrashedComponent from '@app/components/errors/CrashedComponent';
import BroadcastTiles from './BroadcastTiles';
import { theme, Button as AntdButton, Spin, Flex, Col } from '@app/ui';
import { useBroadcastsContext } from '../../BroadcastsContext';
import { getModifiedBroadcast } from '../../utils/broadcastsUtils';
import { Outlet } from 'react-router-dom';

const BroadcastExposures = () => {
    const { t } = useTranslation('measurement');
    const {
        token: { colorPrimary },
    } = theme.useToken();
    const {
        broadcasts,
        filters,
        client,
        showExistingPosts,
        hasPostsAvailable,
        isLoading,
        order,
        morePages,
        _scrollBottom,
        _scrollTop,
        _nextPage,
    } = useBroadcastsContext();

    return (
        <Flex vertical gap={24}>
            <ErrorBoundary FallbackComponent={CrashedComponent}>
                <>
                    {hasPostsAvailable &&
                        showExistingPosts &&
                        order.map((id, index) => {
                            const currentBroadcast = getModifiedBroadcast(
                                filters,
                                broadcasts,
                                id,
                            );
                            if (!currentBroadcast) return null;

                            const { broadcastName, contentDate } =
                                currentBroadcast;

                            return (
                                <BroadcastTiles
                                    key={`broadcast_${broadcastName}_${contentDate}_${index}`}
                                    broadcast={currentBroadcast}
                                    client={client}
                                />
                            );
                        })}
                    {/* This outlet renders the `DetailsModal` when the user is routed to a open exposure */}
                    <Outlet />
                </>
            </ErrorBoundary>
            {hasPostsAvailable && showExistingPosts && (
                <>
                    <Col md={24}>
                        <button
                            id="arrow-down"
                            type="button"
                            className="gds-circular-button gds-circular-button--sm gds-circular-button--gray"
                            onClick={_scrollBottom}
                        >
                            <i className="fas fa-arrow-to-bottom fa-lg" />
                        </button>
                    </Col>
                </>
            )}

            <Col md={24}>
                {isLoading && (
                    <Flex
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Spin size="large" className="-m-t-3" />
                    </Flex>
                )}
                {!isLoading && (
                    <>
                        {!hasPostsAvailable && !isLoading && (
                            <h2 className="gds-text--header-xs -color-tx-lt-5 -text-center -m-t-5">
                                {t('broadcastExposure.noBroadcasts')}
                            </h2>
                        )}
                        <div className="-m-a-4 gds-flex gds-flex--justify-around">
                            {morePages && hasPostsAvailable && (
                                <AntdButton
                                    type="primary"
                                    color="primary"
                                    variant="solid"
                                    onClick={isLoading ? null : _nextPage}
                                >
                                    {t('broadcastExposure.loadMore')}
                                </AntdButton>
                            )}
                            {!morePages && hasPostsAvailable && (
                                <>
                                    <div className="gds-divider gds-divider--centered -m-b-4">
                                        <span className="gds-divider__line" />
                                        <span className="gds-divider__label gds-text--header-xs -m-h-3">
                                            {t(
                                                'broadcastExposure.endOfResults',
                                            )}
                                        </span>
                                        <span className="gds-divider__line" />
                                    </div>
                                    <button
                                        type="button"
                                        className="gds-circular-button gds-circular-button--sm gds-circular-button--secondary"
                                        style={{
                                            background: colorPrimary,
                                            border: colorPrimary,
                                        }}
                                        onClick={_scrollTop}
                                    >
                                        <i className="fas fa-arrow-to-top fa-lg" />
                                    </button>
                                </>
                            )}
                        </div>
                    </>
                )}
            </Col>
            <Col md={24}>
                <div id="bottom" />
            </Col>
        </Flex>
    );
};

export default BroadcastExposures;
